import { Component } from '@theme/component';

/**
 * Header menu — versione "tendina classica".
 *
 * Il comportamento di apertura/chiusura è gestito interamente in CSS
 * (:hover / :focus-within sul .menu-list__list-item). Questo componente
 * mantiene solo il custom element per compatibilità e rende innocue le
 * azioni dichiarative on:pointerenter="/activate" ecc. che nel tema
 * originale guidavano il mega-menu e la "safety box".
 */
export class HeaderMenu extends Component {
  // No-op: la tendina non ha bisogno di logica JS.
  activate() {}
  deactivate() {}
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}
